/** Stable identifiers for every step in the account NUX flow. */
export const ACCOUNT_NUX_STEPS = {
  WELCOME: "welcome",
  ORGANIZATION: "organization",
  PRICING: "pricing",
  PAYMENT: "payment",
  ACTIVATING: "activating",
  SIGNUP_RECOVERY: "signup-recovery",
} as const;

/** Valid identifiers for account NUX steps. */
export type AccountNuxStep =
  (typeof ACCOUNT_NUX_STEPS)[keyof typeof ACCOUNT_NUX_STEPS];

/** User-visible steps in progress-indicator order. */
export const ACCOUNT_NUX_PROGRESS_STEPS: readonly AccountNuxStep[] = [
  ACCOUNT_NUX_STEPS.WELCOME,
  ACCOUNT_NUX_STEPS.ORGANIZATION,
  ACCOUNT_NUX_STEPS.PRICING,
  ACCOUNT_NUX_STEPS.PAYMENT,
];
